import React from 'react';
import { MessageSquare, Clock } from 'lucide-react';
import { formatDistanceToNow } from 'date-fns';
import { fr } from 'date-fns/locale';
import { Conversation } from '../types/Conversation';

interface ConversationHistoryItemProps {
  conversation: Conversation;
  isActive: boolean;
  onSelect: (id: string) => void;
}

export const ConversationHistoryItem: React.FC<ConversationHistoryItemProps> = ({
  conversation,
  isActive,
  onSelect,
}) => {
  return (
    <button
      className={`flex w-full items-start gap-3 rounded-lg px-3 py-2 text-left transition-colors hover:bg-base-200 ${
        isActive ? 'bg-base-200 font-medium' : ''
      }`}
      onClick={() => onSelect(conversation.conversation_id)}
    >
      <MessageSquare className="mt-0.5 size-4 flex-shrink-0 text-base-content/60" />
      <div className="flex flex-col gap-0.5 overflow-hidden">
        <span className="truncate text-sm text-base-content">
          {conversation.conversation_id}
        </span>
        <div className="flex items-center gap-1.5 text-[10px] text-base-content/40">
          <Clock className="size-3" />
          <span>
            {formatDistanceToNow(new Date(conversation.updated_at), {
              addSuffix: true,
              locale: fr,
            })}
          </span>
        </div>
      </div>
    </button>
  );
};
